import { BannerItem } from './banner-item.model';


export class Banner {
    public Id: number;
    public CongressoId: number;
    public PeriodoInterval: number;
    public BannerItem: Array<BannerItem>;
}


// WEBPACK FOOTER //
// ./src/models/banner.model.ts